"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBrowserInfoNamingForMangopay = void 0;
function transformBrowserInfoNamingForMangopay(browserInfo) {
    return {
        AcceptHeader: browserInfo.acceptHeader,
        JavaEnabled: browserInfo.javaEnabled,
        Language: browserInfo.language,
        ColorDepth: browserInfo.colorDepth,
        ScreenHeight: browserInfo.screenHeight,
        ScreenWidth: browserInfo.screenWidth,
        TimeZoneOffset: browserInfo.timeZoneOffset,
        UserAgent: browserInfo.userAgent,
        JavascriptEnabled: browserInfo.javascriptEnabled,
    };
}
exports.transformBrowserInfoNamingForMangopay = transformBrowserInfoNamingForMangopay;
//# sourceMappingURL=transformBrowserInfoNamingForMangopay.js.map